module.exports = __webpack_public_path__ + "img/resource-tech-image-58.3d25ebe7.jpg";